import { useState, useEffect } from 'react';
import { Model } from './Model';
import { Collection } from './Collection';

export type PPCFieldName = string;
export type PPCModel = Model;
export type PPCFieldModel =any;
export function useModel(fieldName:PPCFieldName, model:PPCModel) {
    let currentModel:PPCModel = model;
    let modelToUse:PPCModel = null;
    let fieldNameToUse:String;

    const onBlurEventHandler = (event, fieldName) => {
        let changedValue = null;

        switch(event?.target?.nodeName) {
            case 'INPUT':
                changedValue = event.target.value
                break;
            default:
                changedValue = event.value
                break;

        }

        if(changedValue !== null && modelToUse instanceof Model) {
            let objectToUser = getCurrentModelForFieldName(fieldName, currentModel);
            objectToUser.model.setValue( objectToUser.field, changedValue);
        }
        return false;
    }


    const registerField = (fieldName:PPCFieldName, type:string|null = null) => {
        let fieldModel:PPCFieldModel = getCurrentModelForFieldName(fieldName, model);
        let val = (fieldModel?.model && fieldModel?.model[fieldModel?.field]) ? fieldModel?.model[fieldModel?.field] : '';
        let fieldProps = {
            name: fieldName,
            defaultValue: val,
            type:"text",
            id: fieldName,
            className: 'ppcInputField',
            onBlur: ((event) => onBlurEventHandler(event, fieldName))
        };
        switch(type) {
            case 'editor':
                fieldProps['text'] = val;
                delete fieldProps['defaultValue'];
                delete fieldProps['type'];
                break;

        }


        return fieldProps;
    }

    const tm = (name:string) => {
        let classVar = "bg-red-900";
        return {name: name, className: classVar};
    }
    useEffect(() => {

    }, []);

    function extractFieldName(fieldName) {
        let retVal = fieldName;
        if(fieldName && fieldName.indexOf('.')) {
            let fieldNames = fieldName.split('.');
            retVal = fieldNames.pop();
        }
        return retVal;
    }


function getCurrentModelForFieldName(fieldName:PPCFieldName, model:PPCModel|Collection): PPCFieldModel {
    let returnModel;
    if(fieldName && fieldName.indexOf('.')) {
        let fieldNames = fieldName.split('.');
        if(fieldNames.length > 0) {
            let tmpModel;
            let currentField;
            for(let currentFieldIdx in fieldNames ) {
                currentField = fieldNames[currentFieldIdx];
                if(model instanceof Model && model.hasField(currentField)) {
                    tmpModel = model.getValue(currentField);
                } else if(model instanceof Collection ) {
                    tmpModel = model.getByIndex(parseInt(currentField));
                }
                if(tmpModel instanceof Model || tmpModel instanceof Collection)  {
                    returnModel = model = tmpModel;
                } else {
                    returnModel = model;
                }
            }
            fieldName = currentField;
        }
//        let currentField = fieldNames.shift();
        
    } else {
        if(model instanceof Model && model.hasField(fieldName)) {
            model = model.getValue(fieldName);
        } else if(model instanceof Collection ) {
            model = model.getByIndex(parseInt(fieldName));
        }
        returnModel = model;
            //returnModel = model.getValue(fieldName);     
    }
    modelToUse = returnModel; 
    fieldNameToUse = fieldName;
    return {'model': returnModel, 'field': fieldName};
}

    return {tm, registerField};
}

